@if(isOutside()) {
<div class="flex items-center gap-x-1 rounded-lg border border-red-500 bg-red-100 px-1.5 text-red-500">
  <i class="pi pi-exclamation-triangle"></i>
  <span class="text-value">{{ value }}</span>
</div>
} @else {
<div class="flex items-center rounded-lg px-1.5">
  <span class="text-value justify-self-center">{{ value }}</span>
</div>
}
